import { Category, Translation } from '@wix/answers-api';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import { LOCALES, PRODUCTION_DOMAIN, SEO } from '../../../constants';
import { BasicSeoElements } from '../BasicSEO';
import { useBabelSeo } from '../useBabelSeo';

type CategoryPageProps = {
  category?: Category;
  translations?: Translation[];
};

export const CategoryPageSEO: FunctionComponent<CategoryPageProps> = ({
  category,
  translations,
}) => {
  const resolveBabelSeo = useBabelSeo();
  const interpolation = { categoryTitle: category?.name || '' };
  const title = resolveBabelSeo('seo.category_page.title', interpolation);
  const description = resolveBabelSeo('seo.category_page.description', interpolation);
  const alternateDefaultUrl = translations?.find(
    (e) => e.locale === LOCALES.EN
  )?.url;

  return (
    <>
      <BasicSeoElements
        title={title}
        description={description}
        imageUrl={SEO.SOCIAL_IMAGE_URL}
      />
      <Head>
        {translations?.map(({ url, locale: localeTarget }) => (
          <link
            rel="alternate"
            hrefLang={localeTarget}
            href={`https://${PRODUCTION_DOMAIN}/${localeTarget}${url}`}
            key={url}
          />
        ))}
        {alternateDefaultUrl && (
          <link
            rel="alternate"
            hrefLang="x-default"
            href={`https://${PRODUCTION_DOMAIN}${alternateDefaultUrl}`}
          />
        )}
      </Head>
    </>
  );
};
